import apiClient from './client'

/**
 * API client per gestione Box e Componenti.
 * 
 * Endpoints:
 * - Componenti Scatola: CRUD componenti fisici (fondi, coperchi, etc.)
 * - Configurazioni Scatola: CRUD combinazioni di componenti
 * - Tipologie Box: CRUD box vendibili con composizione prodotti
 */

// ============================================
// COMPONENTI SCATOLA
// ============================================

export const componentiApi = {
  /**
   * Lista componenti scatola con filtri
   * @param {Object} params - Filtri (tipo, attivo, fornitore, search)
   */
  getAll: (params) => apiClient.get('/box/componenti/', { params }),
  
  /**
   * Dettaglio componente
   * @param {number} id - ID componente
   */
  getById: (id) => apiClient.get(`/box/componenti/${id}/`),
  
  /**
   * Crea componente
   * @param {Object} data - Dati componente
   */
  create: (data) => apiClient.post('/box/componenti/', data),
  
  /**
   * Aggiorna componente
   * @param {number} id - ID componente
   * @param {Object} data - Dati aggiornati
   */
  update: (id, data) => apiClient.put(`/box/componenti/${id}/`, data),
  
  /**
   * Aggiorna parzialmente componente
   * @param {number} id - ID componente
   * @param {Object} data - Dati parziali
   */
  patch: (id, data) => apiClient.patch(`/box/componenti/${id}/`, data),
  
  /**
   * Elimina componente
   * @param {number} id - ID componente
   */
  delete: (id) => apiClient.delete(`/box/componenti/${id}/`),
}


// ============================================
// CONFIGURAZIONI SCATOLA
// ============================================

export const configurazioniApi = {
  /**
   * Lista configurazioni scatola con filtri
   * @param {Object} params - Filtri (attivo, search)
   */
  getAll: (params) => apiClient.get('/box/configurazioni/', { params }),
  
  /**
   * Dettaglio configurazione
   * @param {number} id - ID configurazione
   */
  getById: (id) => apiClient.get(`/box/configurazioni/${id}/`),
  
  /**
   * Crea configurazione con componenti
   * @param {Object} data - Dati configurazione + componenti_input
   */
  create: (data) => apiClient.post('/box/configurazioni/', data),
  
  /**
   * Aggiorna configurazione
   * @param {number} id - ID configurazione
   * @param {Object} data - Dati aggiornati
   */
  update: (id, data) => apiClient.put(`/box/configurazioni/${id}/`, data),
  
  /**
   * Elimina configurazione
   * @param {number} id - ID configurazione
   */
  delete: (id) => apiClient.delete(`/box/configurazioni/${id}/`),
}


// ============================================
// TIPOLOGIE BOX
// ============================================

export const tipologieBoxApi = {
  /**
   * Lista tipologie box con filtri
   * @param {Object} params - Filtri (attivo, disponibile_ecommerce, configurazione, search)
   */
  getAll: (params) => apiClient.get('/box/tipologie/', { params }),
  
  /**
   * Dettaglio tipologia box
   * @param {number} id - ID tipologia
   */
  getById: (id) => apiClient.get(`/box/tipologie/${id}/`),
  
  /**
   * Crea tipologia box con composizione prodotti
   * @param {Object} data - Dati tipologia + composizione_input
   */
  create: (data) => apiClient.post('/box/tipologie/', data),
  
  /**
   * Aggiorna tipologia box
   * @param {number} id - ID tipologia
   * @param {Object} data - Dati aggiornati
   */
  update: (id, data) => apiClient.put(`/box/tipologie/${id}/`, data),
  
  /**
   * Aggiorna parzialmente tipologia
   * @param {number} id - ID tipologia
   * @param {Object} data - Dati parziali
   */
  patch: (id, data) => apiClient.patch(`/box/tipologie/${id}/`, data),
  
  /**
   * Elimina tipologia box
   * @param {number} id - ID tipologia
   */
  delete: (id) => apiClient.delete(`/box/tipologie/${id}/`),
  
  /**
   * Calcola breakdown costi e margini
   * @param {number} id - ID tipologia
   */
  calcolaPrezzo: (id) => apiClient.get(`/box/tipologie/${id}/calcola_prezzo/`),
  
  /**
   * Statistiche generali tipologie box
   */
  statistiche: () => apiClient.get('/box/tipologie/statistiche/'),
  
  /**
   * Duplica tipologia box
   * @param {number} id - ID tipologia da duplicare
   * @param {Object} data - { nuovo_codice, nuovo_nome (opzionale) }
   */
  duplica: (id, data) => apiClient.post(`/box/tipologie/${id}/duplica/`, data),
}


// Export default per retrocompatibilità
export default {
  componenti: componentiApi,
  configurazioni: configurazioniApi,
  tipologie: tipologieBoxApi,
}
